module.exports = __webpack_public_path__ + "img/image1.70275f1e.svg";